import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../contexts/auth";
import { CompanyTypes } from "../../../../types/enums";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function NewCreditMemoButton() {

	const navigate = useNavigate();
	const location = useLocation();
	const returnUrl = encodeURIComponent(location.pathname + location.search);

	const { order } = useContext(PurchaseOrderContext);

	const { user } = useAuth();
	const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
		user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

	return (
		<Button
			text="New Credit Memo"
			icon="Inscyth-Payment-Schedule"
			onClick={() => {
				navigate(`/${urlFolder}/credit-memo/${order.details.purchaseOrderID}/new?returnUrl=${returnUrl}`);
			}} >
		</Button>
	)
}
